import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./CustomDropDown.scss"; // Add your styles

const FacilityIdDropdown = ({ location, setLocation, locationOptions }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option) => {
    setLocation(option.id); // Set only the facility_id
    setIsOpen(false);
  };

  // Find the label to display based on the current location (facilityId)
  const selectedOption = locationOptions.find(
    (option) => option.id === location
  );
  const displayLabel = selectedOption ? selectedOption.label : location;

  return (
    <div className="custom-dropdownFacility">
      <div
        className="dropdown-headerLocationFacility"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{displayLabel}</span>
        <ChevronDown size={18} />
      </div>

      {isOpen && (
        <ul className="dropdown-listFacility">
          {locationOptions.map((option) => (
            <li key={option.id} onClick={() => handleSelect(option)}>
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FacilityIdDropdown;
